<!-- CHATBOT PANEL -->
<div
  ref="chatbot"
  class="
    position-fixed bottom-0 end-0
    bg-opacity-90
    bg-collapsable-btn
    shadow-lg
    border
    rounded-4
    d-flex flex-column
    z-3
    chatbot-panel
  "
  :class="{ 'chatbot-open': is_open, 'chatbot-closed': !is_open }"
  role="dialog"
>

  <!-- HEADER -->
  <div
    class="
      px-3 py-2
      btn-primary
      border-bottom border-light border-opacity-25
      d-flex justify-content-between align-items-center
      rounded-top-4
    "
  >
    <div class="d-flex align-items-center gap-3">
      <div class="bg-white bg-opacity-10 p-2 rounded-4 fs-5 text-white">
        <i class="bi bi-robot"></i>
      </div>

      <div>
        <h6 class="text-dark  mb-0">Infinity Assist</h6>
        <small class="text-dark">
          AI Dashboard Assistant
        </small>
      </div>
    </div>

   <button
      class="
        btn btn-sm btn-outline-light border-0
        d-flex align-items-center justify-content-center
      "
      @click="close_assistant"
      aria-label="Close assistant"
    >
      <i class="bi bi-x-lg"></i>
    </button>

  </div>

  <!-- CHAT BODY -->
  <div class="flex-grow-1 p-3 overflow-auto" ref="chat_body">
    <div
      v-for="(msg, index) in messages"
      :key="'msg-' + index"
      class="d-flex w-100 mb-3"
    >
      <!-- USER -->
      <div
        v-if="msg.sender === 'user'"
        class="bg-primary text-white p-2 rounded-3 ms-auto"
      >
        {{ msg.text }}
      </div>

      <!-- ASSISTANT -->
      <div
        v-else
        class="bg-white bg-opacity-10 text-white p-2 rounded-3 me-auto"
      >
        {{ msg.text }}
      </div>
    </div>
  </div>

  <!-- INPUT -->
  <div
    class="
      d-flex align-items-center gap-2
      px-3 py-2
      border-top
      rounded-bottom-4
    "
  >
    <input
      type="text"
      v-model="user_message"
      @keyup.enter="send"
      class="
        form-control
        bg-white bg-opacity-10
        text-white
        border-0
        rounded-3
        shadow-none
      "
      placeholder="Ask me anything…"
    />

    <button
      class="
        btn btn-primary
        rounded-circle
        d-flex align-items-center justify-content-center
      "
      @click="send"
    >
      <i class="bi bi-send-fill"></i>
    </button>
  </div>

</div>